
var referralPeriod1 = 365; 
var url1 = window.location.href; 
var cjData; 
var isCjCookiePresent1 = false; 
if (url1.includes('cjdata')){  
  var start1 = url1.indexOf('cjdata'); 
  var end1 = url1.length; 
  var query1 = url1.substring(start1,end1); 
  var newEnd1 = query1.indexOf('&'); 
  if (newEnd1 == -1) {newEnd1 = query1.length}; 
  cjData = query1.substring(8,newEnd1); 
  console.log('found cjdata in URL: ' + cjData); 
  checkForCjCookie1(); 
} else { 
  checkForCjCookie1(); 
}; 
 
function checkForCjCookie1() { 
  var name = "cjdata="; 
  var decodedCookie = decodeURIComponent(document.cookie); 
  var ca = decodedCookie.split(';'); 
  for(var i=0; i<ca.length; i++) { 
   var c = ca[i]; 
    while (c.charAt(0) == ' ') { 
      c = c.substring(1);  
    } 
    if (c.indexOf(name) == 0) { 
      var value = (c.substring(name.length)); 
      if (cjData != undefined) { 
        console.log('Found CJ Cookie'); 
        isCjCookiePresent1 = true; 
        updateCookie1(); 
} else if (value != undefined){ 
        console.log('Found CJ Cookie, even though nothing in URL'); 
        setCjCookie1('cjdata', value,referralPeriod1); 
      } else { 
//         console.log(i); 
      } 
    } 
  } 
  if (cjData && !isCjCookiePresent1) { 
   console.log('cjdata in URL but no cookie'); 
    setCjCookie1('cjdata', cjData, referralPeriod1); 
  } 
} 
 
function updateCookie1(){ 
  if (isCjCookiePresent1) { 
    console.log('Deleting cookie'); 
    setCjCookie1('cjdata',"",-1); 
    console.log('Adding new cookie'); 
    setCjCookie1('cjdata', cjData, referralPeriod1); 
  } 
} 
 
function setCjCookie1(cname, cvalue, exdays) { 
  var d = new Date(); 
  d.setTime(d.getTime() + (exdays*24*60*60*1000)); 
  var expires = "expires="+ d.toUTCString(); 
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/"; 
  storeId1(cvalue); 
} 
 
function storeId1(cjData) { 
  console.log("storing event ID: " + cjData);  
  $.ajax({ 
    type: "POST", 
    url: '/cart.js', 
    data: {"attributes[pagination]": cjData}, 
    success: function(d) { 
    console.log("success " + d); 
    }, 
  dataType: 'json' 
  }); 
};